export default __webpack_public_path__ + "static/media/Cassette.57d30559.png";